import Nullstack from 'nullstack';
export default function IconBookUpload({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-book-upload",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M14 20h-8a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12v5"
  }), "   ", Nullstack.element("path", {
    d: "M11 16h-5a2 2 0 0 0 -2 2"
  }), "   ", Nullstack.element("path", {
    d: "M15 16l3 -3l3 3"
  }), "   ", Nullstack.element("path", {
    d: "M18 13v9"
  }), " ");
}